module.exports = __webpack_public_path__ + "img/google-color.372ec7a.svg";